// extracted by mini-css-extract-plugin
export default {"pageWrap":"pb-z","fullWidth":"qb-z","heading":"rb-z","fullBleed":"sb-z","hidden":"tb-z"};